import { Injectable } from '@angular/core';

import { getAuth } from '@angular/fire/auth';
import { doc, Firestore, getDoc, updateDoc,query, where, orderBy, collection, getDocs, serverTimestamp, setDoc, writeBatch, collectionGroup, limit, startAt, endAt, endBefore, Timestamp, deleteDoc } from '@angular/fire/firestore';
import * as _ from 'lodash';
import { DashboardMessageService } from './dashboard-message.service';
import { HelperService } from './helper.service';
import { ProjectService } from './project.service';
import { UserService } from './user.service';
import { Subject } from 'rxjs';
import { getFunctions, httpsCallable } from "@angular/fire/functions"
import { getApp } from '@firebase/app';
import { StorageService } from './storage.service';

@Injectable({
  providedIn: 'root'
})
export class QuestionsService {
  lessonData: any = {};
  templates:any = [];
  selectedTemplate: any;
  contentId:any;
  questionList:any = []; 
  athneaActive:any=null
  
  private percentageAthena: Subject<number> = new Subject<number>();
  AthenaPercentage$ = this.percentageAthena.asObservable();

  
  constructor(
    public firestore: Firestore,
    private helpers: HelperService,
    private messageService: DashboardMessageService,
    private userService:UserService,
    private projectService:ProjectService,
    private storageService:StorageService,
  ) {
  }
  public setQuestionList(v : any) {
    this.questionList = v;
  }
  public setAthenaActive(v : any) {
    this.athneaActive = v;
  }
  
  public getAthenaActive() {
    return  this.athneaActive
  }
  
  public getQuestionList() {
    return this.questionList;
  }

  generateQuestionsFromAI(data:any){
    return new Promise(async (resolve: any, reject: any) => {
			const functions = getFunctions(getApp());
			var generateQuestions = httpsCallable(functions, 'chatGpt/generateQuestions');

			generateQuestions(data).then((result: any) => {
        // if (result && result.data == 'question_added') {
        //   this.messageService.changeMessage("refresh-question-list")
        // }
				resolve(result)
			}).catch((err: any) => {
				// console.log(err)
				reject(err)
			});
		});
  }

  editImageFromAI(data:any){
    return new Promise(async (resolve: any, reject: any) => {
			const functions = getFunctions(getApp());
			var editImage = httpsCallable(functions, 'chatGpt/editImage');

			editImage(data).then((result: any) => {
        // if (result && result.data == 'question_added') {
        //   this.messageService.changeMessage("refresh-question-list")
        // }
				resolve(result)
			}).catch((err: any) => {
				console.log(err)
				reject(err)
			});
		});
  }

//After deletion updated questionCount on quiz_stats
  public updateTotalNumberOfQuestions(quizId:any,questionCount: number) {
    return new Promise((resolve, reject) => {
      let docRef = doc(this.firestore,'quiz_stats',quizId)
      updateDoc(docRef,{'questionCount':questionCount})
        .then((result) => {
          resolve(result);
        })
        .catch((err) => {
          reject(err);
        });
    });
  }

//Get questionCount on quiz_stats
  public async getTotalNumberOfQuestions(quizId:any) {
    let ref =doc(this.firestore,'quiz_stats', quizId)
    let question:any = null;
    await getDoc(ref).then(doc => {
        question = doc.data();
        question.id = doc.id;
      })
      .catch((err) => {
        question = null;
      });
    return question;
  }

  public async getAllQuestionsByProjectId(quizId: any, contentId:any=null) {
    return new Promise(async (resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef()
      if(contentId==="contributors"){
          contentId = userContentRef.contentId
        const questionsRef = query(collection(this.firestore,'contentAccountMapping', contentId, 'contributors', quizId, 'question'),where('questionStatus','!=','t'),orderBy('questionStatus'), orderBy('creationDate'))
        let questions: any = [];
        await getDocs(questionsRef).then((snapshot) => {
          snapshot.forEach((doc: any) => {
            var q = doc.data();
            q['questionId'] = doc.id; // incase there are questions without id. some old questions.
            questions.push(q);
          });
          questions =  _.orderBy(questions, ['sequence'],['asc']);
          resolve(questions)
        }).catch(err => {
          reject(err)
        })
  
      }  else{
        if (!contentId) {
          contentId = userContentRef.contentId
        }
        const questionsRef = query(collection(this.firestore,'contentAccountMapping', contentId, 'quiz', quizId, 'question'),where('questionStatus','!=','t'),orderBy('questionStatus'), orderBy('creationDate'))
      let questions: any = [];
      await getDocs(questionsRef).then((snapshot) => {
        snapshot.forEach((doc: any) => {
          var q = doc.data();
          q['questionId'] = doc.id; // incase there are questions without id. some old questions.
          questions.push(q);
        });
        questions =  _.orderBy(questions, ['sequence'],['asc']);
        resolve(questions)
      }).catch(err => {
        reject(err)
      })
      }
      
  })

  }
  public async getQuestionDetailsByQuestionId(quizId:any,questionId:any) {
    let userContentRef = this.userService.getUserContentRef()
    let ref = doc(this.firestore,'contentAccountMapping',userContentRef.contentId,'quiz',quizId,'question',questionId)
    let question:any = null;
    await getDoc(ref).then((doc) => {
      question = doc.data();
      question.questionId = doc.id;
    })
    .catch((err) => {
      question = null;
    });
    return question;
  }

  public updateQuestions(quizId:any,questionId:any, questionDetails:any ,contentId:any=null) {
    return new Promise(async (resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef()
      if(!contentId)
        contentId = userContentRef.contentId
      const updatedOn = serverTimestamp();
      // const updatedBy = getAuth().currentUser?.uid;
      questionDetails.updatedBy =  contentId //updatedBy;
      questionDetails.updatedOn = updatedOn;
      let docRef =doc(this.firestore,'contentAccountMapping',contentId,'quiz',quizId,'question',questionId)
      try {
        let result = await updateDoc(docRef,questionDetails)
        resolve(result)
          // .then((result) => {
          //   resolve(result);
          // })
          // .catch((err) => {
          //   reject(err);
          // });
        
      } catch (error) {
        reject(error)
      }
    });
  }

  async createNewQuestion(project: any, questionType: any,questionLength:any, themeData:any = null) {
  //   console.log('project',project,
  //  'questionType', questionType , 'questionLength',questionLength)
    return new Promise(async (resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef()
      if (!(project && project.quizId)) reject(null);
      this.getNewQuestion(userContentRef,project, questionType,questionLength).then((question: any) => {
        if(question.questionType == "d" && question.questionStatus=='s')
          question.accuracyValue = 0;
        // console.log('default question object ', question)

        // mimir question document structure
        // questionObj = {
          // 'answerText': row.answerText,
          //   'questionPageLayout': 'fib-openbox',
          //   'questionCategory': {},
          //   'roundNo': row.roundNo,
          //   'questionNo': row.questionNo,
          //   'notes': row.notes,
          //   'imageUrl': row.imageUrl,
          // }
        // check for mimir question data
        if(project.quizType == 'mimir'){
          question.questionPageLayout = 'fib-openbox';
          question.showAnswerInfo = true;
          question.questionCategory = themeData.questionCategory;
          question.themeDescription = themeData.themeDescription;
          question.difficulty = themeData.difficulty;
          if(themeData.quadOrder)
            question.quadOrder = themeData.quadOrder;
          if(themeData.tieBreakQue)
            question.tieBreakQue = themeData.tieBreakQue
          if(themeData.spareQue)
            question.spareQue = themeData.spareQue
        }
        if(project.quizType == 'masterMind'){
          question['usedStatus']='unUsed'
        }
        if(project.quizType == 'mimir' ||project.quizType == 'masterMind' ){
          question['athena']={
            speakUrl:'',
            modified:true
          }
        }
        if (question && question.questionId) {
          let questionsRef = doc(this.firestore,'contentAccountMapping',userContentRef.contentId,'quiz',project.quizId, 'question', question.questionId)
          setDoc(questionsRef, question).then((result) => {
            resolve(question);
          }).catch((err) => {
            reject(err);
          });
        }
      })
        .catch((err) => {
          reject(err);
        });
    });

    // this.saveQuestion(question);
  }


  CreateNewQuestionsForMasterMind(project: any,question:any = null){
    return new Promise(async (resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef()
    let questionsRef = doc(this.firestore,'contentAccountMapping',question.contentId,'quiz',project.quizId, 'question', question.questionId)
    setDoc(questionsRef, question).then((result) => {
      resolve(question);
    }).catch((err) => {
      reject(err);
    });
  })
  }

  getNewQuestion(userContentRef:any,project: any,questionType:any,questionLength:any) {
    return new Promise((resolve, reject) => {
      let templetRef = collection(this.firestore, 'content_templates');
      var queryRef:any;
      if(project && project?.quizType == 'assessment'){
        queryRef = query(templetRef,where('quizType','==','assessment'))
      }else{ 
        queryRef = query(templetRef, where('questionType', '==', questionType))
      }
      let templates:any = [];
      getDocs(queryRef).then((results:any) => {
          if (!results.empty) {
            results.docs.forEach((doc:any) => {
              var q = doc.data();
              templates.push(q);
            });
          }
          if (templates.length) {
            let template = templates[0];
            //get question details from template
            let question =this.getQuestionDetails(project,template)
            if(questionType == 'f'){ //set default questionPageLayout = fib-openbox
              question['questionPageLayout'] = template.questionPageLayout?template.questionPageLayout:'fib-openbox'
            }
            if(questionType == 'd'){
              question.maxValue = template.maxValue;
              question.minValue = template.minValue;
              question.stepValue = template.stepValue;
            }
            //if question type is multiple choice then add options field
            if(questionType == 'm')
              question.options = template.options ? template.options : [],
            //Also send the questionCategories to the editor
            // question['questionCategories'] = project.questionCategories;
            question['refAccountId'] = userContentRef.refAccountId;
            question['refContentId'] = userContentRef.contentId;
            question['refQuizId'] = project.quizId;
            question['sequence'] = project.quizType == "mimir" ? questionLength : questionLength + 1;
            resolve(question);
          } else {
            reject(null);
          }
        }
      ).catch((error:any) => {
        reject(error);
      });
    });
  }

    //get question stats by project id
    public async getAllQuestionStatsByProjectId(key:any,quizId:string) {
      return new Promise((resolve, reject) => {
        let statsRef = collection(this.firestore, 'question_stats');
        let questionStatsref = query(statsRef, where(key, "==", quizId));
        let questionStats:any = {}
        getDocs(questionStatsref).then((results) => {
          if (!results.empty) {
            results.docs.forEach((doc) => {
              var q = doc.data();
              q['id'] = doc.id;
              questionStats[doc.id] = q;
            });
          }
          resolve(questionStats);
        }, error => reject(error));
      });
    }

  getQuestionDetails(project:any,template:any){
    var question: any = {
      questionId: this.helpers.uuidv4(),
      questionStatus:'s',
      questionType: template.questionType ? template.questionType : 'None', //byDefault
      questionText: template.richText ? template.richText : template.name,
      correctAnswer: template.correctAnswer? template.correctAnswer : '',
      questionImage: template.questionImage? template.questionImage : '',
      answerImage: template.answerImage? template.answerImage : '',
      answerDescription: template.answerDescription? template.answerDescription: '',
      source: '',
      difficulty: 2, //medium by default
      tag: [],
      refCategoryId:"",
      refSubCategoryId:"",
      creationDate: serverTimestamp(),
      createdBy: getAuth().currentUser?.uid,
      creatorName: getAuth().currentUser?.displayName,
      geoLocationText:'',
      theme:[]
    };
    if(project && project?.quizType=='assessment'){
      question['questionType'] = 'm'
    }
    return question;
  }

  copyQuestionsFromTemplateToQuiz(quiz:any) {
    return new Promise(async (resolve, reject) => {
      if (quiz && quiz.refTemplateId && quiz.quizId) {
        let questions:any = await this.getAllQuestionsByProjectId(quiz.refTemplateId, quiz.preRefContentId);
        let userContentRef = this.userService.getUserContentRef()
        
        if (questions && questions.length) {
          const batch = writeBatch(this.firestore);
          questions.forEach((question:any) => {
            delete question['updatedOn'];
            delete question['updatedBy'];
            question['questionId'] = this.helpers.uuidv4();
            question['creationDate'] = serverTimestamp();
            question['createdBy'] = getAuth().currentUser?.uid;
            question['creatorName'] = getAuth().currentUser?.displayName;
            question['refAccountId'] = userContentRef.refAccountId;
            question['refContentId'] = userContentRef.contentId;
            question['refQuizId'] = quiz.quizId;
            let quesRef = doc(this.firestore,'contentAccountMapping', userContentRef.contentId, 'quiz', quiz.quizId, 'question', question.questionId)
            batch.set(quesRef, question);
          });
          await batch.commit();
          this.messageService.changeMessage("refresh-question-list");
        }
        resolve(questions)
      } else {
        reject(null)
      }
    })
  }

// Get all questions of content id
  public getQuestionsForAccountId(startDate:any,endDate:any) {
    return new Promise(async (resolve, reject) => {
      try {
        const questionsRef = query(collectionGroup(this.firestore, 'question'), where('questionStatus', 'in', ['s', 'u','']), orderBy('creationDate'),startAt(startDate),endBefore(endDate))
        const querySnapshot = await getDocs(questionsRef);
        let questions: any = [];
        querySnapshot.forEach((doc) => {
          var q:any = doc.data();
          q['questionId'] = doc.id; // incase there are questions without id. some old questions.
          q['quizId']=q.refQuizId
          q['refContentId']=q.refContentId
          // q['quizName']=quiz.quizName
          // q['quizDescription']=quiz.quizDescription
          questions.push(q);
          // console.log(doc.id, ' => ', doc.data());
        });
        resolve(questions)
      } catch (error) {
        console.log(error)
      }
      // let userContentRef = this.userService.getUserContentRef()
      // let contentRef = collection(this.firestore, 'contentAccountMapping')
      // let q: any = query(contentRef, where('refAccountId', '==', userContentRef.refAccountId))
      // let quiz: any;
      // let contentIds: any = [];
      // await getDocs(q).then((docs) => {
      //   docs.forEach((doc) => {
      //     quiz = doc.data();
      //     contentIds.push(quiz.contentId)
      //   })
      // })
      // let quizsPromise = [];
      // for (let idx = 0; idx < contentIds.length; idx++) {
      //   let contentId = contentIds[idx];
      //   quizsPromise.push(this.projectService.getProjectByContentId(contentId))
      // }
      // Promise.all(quizsPromise).then((result) => {
      //   let quizList: any = [];
      //   result.forEach((questions: any) => {
      //     if (questions) {
      //       quizList = quizList.concat(questions)
      //     }
      //   })

    //     let questionPromise: any = [];
    //     for (let idx = 0; idx < quizList.length; idx++) {
    //       let quiz = quizList[idx];
    //       questionPromise.push(this.getAllQuestionsForTaggingQuestion(quiz, quiz.refContentId))
    //     }
    //     Promise.all(questionPromise).then((result) => {
    //       let questionList: any = [];
    //       result.forEach((questions: any) => {
    //         if (questions) {
    //           questionList = questionList.concat(questions)
    //         }
    //       })
    //       resolve(questionList)
    //     }).catch((err) => {
    //       console.log(err)
    //       resolve([])
    //     })

    //   }).catch((err) => {
    //     console.log(err)
    //     resolve([])
    //   })
    })
  }

  // public async getAllQuestionsForTaggingQuestion(quiz: any, contentId:any=null) {
  //   return new Promise(async (resolve, reject) => {
  //     let userContentRef = this.userService.getUserContentRef()
  //     if (!contentId) {
  //       contentId = userContentRef.contentId
  //     }
  //     const questionsRef = query(collection(this.firestore,'question'),where('questionStatus','not-in',['t','j']),orderBy('questionStatus'), orderBy('creationDate'))
  //     let questions: any = [];
  //     await getDocs(questionsRef).then((snapshot) => {
  //       snapshot.forEach((doc: any) => {
  //         var q = doc.data();
  //         q['questionId'] = doc.id; // incase there are questions without id. some old questions.
  //         q['quizId']=quiz.quizId
  //         q['quizName']=quiz.quizName
  //         q['quizDescription']=quiz.quizDescription
  //         q['refContentId']=contentId
  //         questions.push(q);
  //       });
  //       resolve(questions)
  //     }).catch(err => {
  //       reject(err)
  //     })

  //   });
  // }

  // Get questions for questions bank
  // public getQuestionsForQuestionsBank(user:any,data:any,project:any) {
  //   return new Promise(async (resolve,reject) => {
  //     // let userContentRef = this.userService.getUserContentRef()
  //     let quizRef:any = collection(this.firestore,'contentAccountMapping',user.uid,'quiz')
  //     let quiz:any;
  //     let quizIds:any = [];
  //     await getDocs(quizRef).then((docs)=>{
  //       docs.forEach((doc)=>{
  //         quiz = doc.data();
  //         if(project.quizId != quiz.quizId) //current project quizId not pushing
  //         {
  //           quizIds.push(doc.id)
  //         }
  //         // console.log("not pushing: ",quizIds)
  //       })
  //     })
  //     let quizsPromise = [];
  //     for (let idx = 0; idx < quizIds.length; idx++){
  //       let quizId = quizIds[idx];
  //       let userContentRef = this.userService.getUserContentRef()
  //       let contentId = userContentRef.contentId
  //       quizsPromise.push(this.getAllQuestionsForQuestionsBank(quizId, contentId, data))
  //     }
  //     Promise.all(quizsPromise).then((result)=>{
  //       let questionList:any = [];
  //       result.forEach((questions:any)=>{
  //         if (questions){
  //           questionList = questionList.concat(questions)
  //         }
  //       })
  //       resolve(questionList)
  //     }).catch((err)=>{
  //       console.log(err)
  //       resolve([])
  //     })
  //   })
  // }

  public async getQuestionsForQuestionsBank(user:any,data:any,project:any) {   //data = selectedCategoryField, workspace, timePeriod, questionCount
    return new Promise(async (resolve, reject) => {
      let questionsRef:any
      let startTime:any
      //set time preiod
      if(data.timePeriod == "sixMonth"){
        startTime = Timestamp.fromDate(new Date(data.lastSixMonthDate))
      }else{
        startTime=Timestamp.fromDate(new Date(1546323829000))
      }

      if(data.workspace == 'myContent'){
        let userContentRef = this.userService.getUserContentRef()
        questionsRef = query(collectionGroup(this.firestore,'question'),where('questionStatus','not-in',['t','j']),where('refCategoryId','==',data.selectedCategoryField),where('refContentId','==',userContentRef.contentId),orderBy('questionStatus'),orderBy('creationDate'),startAt(startTime))
      }else{
        let refAccountId = 'ebGl6wWxjERc6cHt0fDQ'
        questionsRef = query(collectionGroup(this.firestore,'question'),where('questionStatus','not-in',['t','j']),where('refCategoryId','==',data.selectedCategoryField),where('refAccountId','==',refAccountId),orderBy('questionStatus'),orderBy('creationDate'),startAt(startTime))
      }

      let questions: any = [];
      let questionType = data.typeChange.split(',')
      await getDocs(questionsRef).then((snapshot) => {
        snapshot.forEach((doc: any) => {
          var q = doc.data();
          q['questionId'] = doc.id;
          if(questionType.includes(q['questionType']))
            questions.push(q);
        });
        resolve(questions)
      }).catch(err => {
        reject(err)
      })

    });
  }

  copyQuestionsFromQuestionBank(questions:any,project:any){
    return new Promise(async (resolve, reject) => {
      if (project.quizId) {
        let userContentRef = this.userService.getUserContentRef()
        let user = this.userService.getUser() //get user details
        if (questions && questions.length) {
          questions.forEach((question:any) => {
            question['questionId'] = this.helpers.uuidv4();
            question['creationDate'] = serverTimestamp();
            question['createdBy'] = getAuth().currentUser?.uid;
            question['creatorName'] = getAuth().currentUser?.displayName;
            question['refAccountId'] = userContentRef.refAccountId;
            let quesRef = doc(this.firestore,'contentAccountMapping', userContentRef.contentId, 'quiz', project.quizId, 'question', question.questionId)
            setDoc(quesRef ,question, {merge:true});
            this.messageService.changeMessage("new-question-added");
          });
        }
      }
    resolve(questions)
    })
  }
  // get question stats by QuestionId (doc id)
  public getQuestionStatsByQuestionId(questionDetails:any){
    return new Promise(async (resolve,reject)=>{
      let questionsRef = doc(this.firestore,'question_stats',questionDetails.questionId??questionDetails.question)
      let questions:any = {};
      await getDoc(questionsRef).then((doc) => {
        questions = doc.data();
        resolve(questions)
      }).catch(err => {
        reject(err)
      })
    })
  }
  // update question stats by questionId (doc id)
  public setQuestionStats(getQuestionStats:any,questionId:any) {
    return new Promise((resolve, reject) => {
      const questionStatsRef:any = doc(this.firestore,'question_stats',questionId)
      setDoc(questionStatsRef,getQuestionStats, {merge:true})
        .then((result) => {
          // console.log("after questats updation result : ",result)
          resolve(true);
        })
        .catch((err) => {
          console.log("err : ",err)
          reject(err);
        });
    });
  }

  // get question stats by QuestionId For LiveQuiz (doc id)
  public getQuestionStatsForLiveQuizByQuestionId(docId:any){
    return new Promise(async (resolve,reject)=>{
      let questionsRef = doc(this.firestore,'question_stats',docId)
      let questions:any = {};
      await getDoc(questionsRef).then((doc) => {
        questions = doc.data();
        resolve(questions)
      }).catch(err => {
        reject(err)
      })
    })
  }
  // update question stats by questionId For LiveQuiz (doc id)
  setQuestionStatsForLiveQuiz(answerObj:any,getQuestionStats:any) {
    return new Promise(async (resolve, reject) => {
      const questionStatsRef:any = doc(this.firestore,'question_stats',answerObj.question+"_"+answerObj.liveQuizId)
      await setDoc(questionStatsRef,getQuestionStats, {merge:true}).then((result) => {
        resolve(getQuestionStats);
      }).catch((err) => {
        reject(err);
      });
    });
  }
////for live  saving drs form dash board 
  savedDrs(liveId:any, questionId:any, data:any){
    return new Promise(async (resolve, reject) => {
    let liveQuizRef = doc(this.firestore, 'liveQuiz', liveId, 'answerReview', questionId);
    setDoc(liveQuizRef, data, {merge:true}).then((result) => {
      resolve(result);
    }).catch((err) => {
      // reject(err);
      console.log("err=>",err)
    });
    })
    }



  // quiz Form submit
  async quizFormQuestionsCreate(quizId: any, questionList:any) {
    return new Promise(async (resolve, reject) => {
      // let userContentRef = this.userService.getUserContentRef()
      //   let ContentId=userContentRef.contentId;

      let questionsRef = doc(this.firestore,'contentAccountMapping',questionList.refContentId,'quiz',quizId, 'question', questionList.questionId)
      setDoc(questionsRef, questionList).then((result) => {
        resolve(true);
      })
        .catch((err) => {
          console.log("error=>",err)
          reject(false);
        });
    });
  }
  

  async quizFormQuestionsSave(quizId: any, questionList:any) {
    return new Promise(async (resolve, reject) => {
      let questionsRef = doc(this.firestore,'contentAccountMapping',questionList.refContentId,'contributors',quizId, 'question', questionList.questionId)
      setDoc(questionsRef, questionList ).then((result) => {
        resolve(true);
      })
        .catch((err) => {
          console.log("error=>",err)
          reject(false);
        });
    });
  }
  getQuizQuestionFormContributors(uid:any, quizId:any){
    return new Promise(async (resolve, reject) => {
      let quizRef = query(collection(this.firestore,'contentAccountMapping',uid, 'contributors',quizId,"question"),orderBy("creationDate")) ;
      let querySnapshot = await getDocs(quizRef)
      let questions:any = []
      querySnapshot.forEach((doc) => {
        //  let date =doc.data().creationDate;
        let data:any={}
          data= doc.data();
        questions.push(data);
      });
      resolve(questions)
    }).catch((err) => {
      console.log(err)
      // resolve([])
    })

  }


  async quizUploadQuestionsSave(quizId: any, questionList:any) {
    return new Promise(async (resolve, reject) => {
      let questionsRef = doc(this.firestore,'contentAccountMapping',questionList.refContentId,'quiz',quizId, 'question', questionList.questionId)
      setDoc(questionsRef, questionList ).then((result) => {
        resolve(true);
      })
        .catch((err) => {
          console.log("error=>",err)
          reject(false);
        });
    });
  }

  //==========for adding tags in database=============
  addtags(contentId:any, quizId:any,questionId:any,tags:any){
    return new Promise(async (resolve, reject) => {
      let questionsRef = doc(this.firestore,'contentAccountMapping',contentId,'quiz',quizId, 'question', questionId)
      setDoc(questionsRef, tags ,{merge:true} ).then((result) => {
        resolve(true);
      })
        .catch((err) => {
          console.log("error=>",err)
          reject(false);
        });
    });
  }


  // get all questions by projectId
  public async _getAllQuestionsByProjectId(quizId: any) {
    return new Promise((resolve, reject) => {
      let userContentRef = this.userService.getUserContentRef()
      const questionsRef = query(collection(this.firestore,'contentAccountMapping', userContentRef.contentId, 'quiz', quizId, 'question'),where('questionStatus','!=','t'),orderBy('questionStatus'), orderBy('creationDate'))
      let questions: any = [];
      getDocs(questionsRef).then((snapshot) => {
        snapshot.forEach((doc: any) => {
          var q = doc.data();
          q['questionId'] = doc.id;
          questions.push(q);
        })
        questions =  _.orderBy(questions, ['sequence'],['asc']);
        resolve(questions)
      }).catch(err => {
        reject(err)
      })
    })
  }
  // public async _getAllQuestionsByProjectIdWithQuery(quizId: any   ,limitNumber:number ,status:string='unUsed' ) {
  //   return new Promise((resolve, reject) => {
  //     let userContentRef = this.userService.getUserContentRef()//where('usedStatus','==','unUsed'),limit(limitNumber)
  //     const questionsRef = query(collection(this.firestore,'contentAccountMapping', userContentRef.contentId, 'quiz', quizId, 'question'),where('questionStatus','!=','t'),where('usedStatus','==',status),limit(limitNumber))
  //     // const questionsRef = query(collection(this.firestore,'contentAccountMapping', userContentRef.contentId, 'quiz', quizId, 'question'),where('questionStatus','!=','t'),where('masterMindRound','==',round), where('playerMasterMind','==',playerMasterMind))
  //     let questions: any = [];
  //     getDocs(questionsRef).then((snapshot) => {
  //       snapshot.forEach((doc: any) => {
  //         let data:any = doc.data();
  //            data['questionId'] = doc.id;
  //         questions.push(data);
  //         // console.log("quesitons=====> ", doc.data())
  //       })
  //       // questions =  _.orderBy(questions, ['sequence'],['asc']);
  //       resolve(questions)
  //     }).catch(err => {
  //       reject(err)
  //     })
  //   })
  // }

  updateQuestionsForPreviewQuestionDrog2(quizId:any,_questions:any ,contentId:any=null) {
    return new Promise((resolve, reject) => {
      _questions.forEach((ele:any,index:any) => {
        let data = {
          usedStatus:'unUsed'
        }
        let docRef =doc(this.firestore,'contentAccountMapping',contentId,'quiz',quizId,'question',ele.questionId)
        setDoc(docRef,data, { merge: true })
        // console.log('true')
      })
      resolve(true);
    })
  
  }
  



  // update questions drog changes
  updateQuestionsForPreviewQuestionDrog(quizId:any,_questions:any ,contentId:any=null) {
    return new Promise((resolve, reject) => {
      _questions.forEach((ele:any,index:any) => {
        let data = {
          sequence:index+1,
          updatedBy:serverTimestamp()
        }
        let docRef =doc(this.firestore,'contentAccountMapping',contentId,'quiz',quizId,'question',ele.questionId)
        setDoc(docRef,data, { merge: true })
        // console.log('true')
      })
      resolve(true);
    })
  }
  
  deleteQuestionPermanently(quizId:any,questionId:any,contentId:any) {
    return new Promise((resolve, reject) => {
      let docRef =doc(this.firestore,'contentAccountMapping',contentId,'quiz',quizId,'question',questionId)
      deleteDoc(docRef).then(result => {
        resolve(true)
      }).catch(err => {
        reject(err)
      })
    })
  }




// ============code for athena=====================



async getQuestionDetailsAthena( _project:any , deactive:any=null ,isModifyCheck:any=null, question:any=null ,voiceObject:any={languageCode:'en-GB', name:'en-GB-Neural2-A'}){
  return new Promise(async (resolve, reject) => {

  try {
    if(!deactive){
      // this.AthenaSubject.next(true);
      if(!isModifyCheck) this.questionList =  await  this.getAllQuestionsByProjectId(_project.quizId) 
      else this.questionList=isModifyCheck  
      let length = this.questionList.length;
      if(length==0){
        resolve('msg')
        return
      }
      let isAthenaActivated= _project.athenaActivated;
      if(_project.athenaVoiceNew && _project.athenaVoiceNew.activated  ){
        voiceObject=_project?.athenaVoiceNew?.voiceObject
      }
      const differentVoice= _project.differentVoice;

      if(  (isAthenaActivated!=false && !isAthenaActivated) || differentVoice ){  ///this runs for the first time only 
        // this.athenaLoader=true
          for (let i =0; i<length; i++){
            // let questionData= this.questionList[i]
            let text = this.questionList[i].questionText;
            let id= this.questionList[i].questionId
            let speakUrl= await this.getSpeakUrl(text,id ,_project ,null, voiceObject)
            this.questionList[i]['athena']={speakUrl,   modified:false};
            if(speakUrl ){   ///getting the percentage for it 
              let percentage:any = ((i + 1) / length) * 100;
              percentage=percentage.toFixed(1)
              this.percentageAthena.next(percentage);
             if(percentage>98){
              percentage=98;
              this.percentageAthena.next(percentage);
             }
            }

          }
          for (let j =0; j<length; j++){
            let questionData= this.questionList[j]
            let id= this.questionList[j].questionId
             await this.updateQuestions(_project.quizId, id,questionData )
          }
           _project['athenaActivated']= true
          if(differentVoice) _project['differentVoice']=false
          await this.projectService.updateProject(_project.quizId,_project )
          
          this.percentageAthena.next(100);

          resolve(true)
      }else{  ///for updating
        // this.athenaLoader=true
        let modifiedTextDoc= []   
        for (let i =0; i<length; i++){
          // let questionData= this.questionList[i]
          if(!this.questionList[i].athena){
            this.questionList[i]['athena']={
                                speakUrl:'',
                                modified:true
                              }
          }
          let modified = this.questionList[i].athena.modified
          if(modified){
            let text = this.questionList[i].questionText;
            let id= this.questionList[i].questionId;
            modifiedTextDoc.push(this.questionList[i])
            let speakUrl= await this.getSpeakUrl(text,id , _project, null,voiceObject)
            this.questionList[i]['athena']={speakUrl,   modified:false};
          }
        }
        if(modifiedTextDoc.length>0){
          let length2= modifiedTextDoc.length
          for (let j =0; j<length2; j++){
            let questionData= modifiedTextDoc[j]
            let id= questionData.questionId
             await this.updateQuestions(_project.quizId, id,questionData )
          }
        }
        this.percentageAthena.next(50);
        let urlSpeak:any
        if(question){
          urlSpeak= this.isUrlSync(this.questionList,question.questionId)
        }

        _project['athenaActivated']= true
        await this.projectService.updateProject(_project.quizId,_project )
        this.percentageAthena.next(100);
         if(question) resolve(urlSpeak)
         else resolve(true)
      }
      // this.athenaLoader=false
    }else{
      // this.AthenaSubject.next(false);
      _project['athenaActivated']= false
      await this.projectService.updateProject(_project.quizId,_project )
        resolve(true)
        
    }
  
  } catch (error) {
      console.log("error while athena ", error)
      reject(false)
  }
})
 
}




isUrlSync(arr:any , questionId:any) {
  for (const obj of arr) {
    // if (obj.questionId && obj.athena.modified === true) {
    //   return true;
    // }
    if (obj.questionId==questionId) {
      return obj.athena.speakUrl;
    }
  }
  return false;
}
async getSpeakUrl(text:any, questionId:any , _project:any , directUse:any=null , voiceObject:any){
  return new Promise(async (resolve, reject) => {
try {
  text=this.removeHtmlTags(text)
  let data={
    text,
    voice: {
          languageCode:voiceObject.languageCode,               //'en-GB',   //'en-IN',       (using uk FEMALE VOICE  Ref:==>https://cloud.google.com/text-to-speech/docs/voices)
          name:voiceObject.name                               //n-GB-Neural2-A' // 'en-IN-Neural2-C', 
        },
  }
  let audio=  await this.userService.speakText(data)
  if(directUse){
    resolve(audio)
    return
  }
   let file= await  this.urltoFile(audio, `${questionId}.mp3`, 'audio/mpeg')
  let downloadUrl=  await  this.storageService.audioUpload(file, file.name , _project.quizId)
  resolve(downloadUrl)
} catch (error) {
    console.log("error while athena ", error)
    reject(false);
}
 })
 
}

  urltoFile(url: any, filename: any, mimeType: any) {
    return (fetch(url)
      .then(function (res) { return res.arrayBuffer(); })
      .then(function (buf) { return new File([buf], filename, { type: mimeType }); })
    );
  }

  
  removeHtmlTags(input: string) {
    //  return  input.replace(/<[^>]+>| /g, '');
  
      // let cleanedInput = input.replace(/<[^>]+>| /g, '');
      // return cleanedInput.replace(/_+/g, '_');
      // ================blank =======================
      let cleanedInput = input.replace(/<[^>]+>|&nbsp;/g, '');
      let arr= cleanedInput.split(" ")
      for(let index =0; index <arr.length; index++){
        let el=arr[index]
        if(!el.includes('@')){
          const underscoreCount = (el.match(/_/g) || []).length;
          if(el.includes('&amp')){
            el=  el.replace(/&amp;/g, '&');
          }                   
          if(underscoreCount>1){
            let missingUnderscores = 5 - underscoreCount;  
            if (missingUnderscores >= 1) {
              if(missingUnderscores==1){
                missingUnderscores=2
              }
              el = el.replace(/_/g, '_'.repeat(missingUnderscores));
            }
          }
            if (el.includes('__')) {
                const firstUnderscoreIndex = el.indexOf('_');
                const lastUnderscoreIndex = el.lastIndexOf('_');
                el = el.substring(0, firstUnderscoreIndex) + ' ' +
                               el.substring(firstUnderscoreIndex, lastUnderscoreIndex + 1) +
                               ' ' + el.substring(lastUnderscoreIndex + 1);
            }
        }  
          arr[index]= el
      }
      let cleanedInput2= arr.join(' ')
        return cleanedInput2;
    }

}
